import { setCookie } from "@insite/client-framework/Common/Cookies";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps { }

const mapStateToProps = (state: ApplicationState) => ({
    pagination: getProductListDataViewProperty(state, "pagination"),
});

const mapDispatchToProps = {
    addProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface ProductListPaginationStyles {
    pagination?: PaginationPresentationProps;
    paginationCustom?: InjectableCss;
}

export const paginationStyles: ProductListPaginationStyles = {
    paginationCustom: {
        css: css`
            @media screen and (max-width: 1279px) {
                justify-content: left;
                display: block;
                > span {
                    text-align: left;
                    justify-content: left;
                    width: 49%;
                    margin-top: 0;

                    > div {
                        display: block;

                        label {
                            text-align: left;
                        }

                        > div {
                            max-width: 6.25rem;
                            width: 6.25rem;
                        }
                    }
                }
            }
        `
    }
};

const styles = paginationStyles;

const ProductListPagination: FC<Props> = ({ addProductFilters, pagination }) => {
    const changePage = (newPageIndex: number) => {
        addProductFilters({ page: newPageIndex });
        setTimeout(() => {
            if (typeof window !== "undefined") {
                if (window.innerWidth < 768) {
                    window.scrollTo({ top: 150, behavior: "auto" });
                }
                else {
                    window.scrollTo({ top: 0, behavior: "auto" });
                }
            }
        }, 100);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        addProductFilters({ pageSize: newPageSize });
    };

    if (!pagination || !pagination.totalItemCount) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination!.totalItemCount}
            currentPage={pagination!.page}
            resultsPerPage={pagination!.pageSize}
            resultsPerPageOptions={pagination!.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie="ProductList-PageSize"
            {...styles.paginationCustom}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListPagination),
    definition: {
        group: "Product List",
        displayName: "Pagination",
        allowedContexts: [ProductListPageContext],
    },
};

export default widgetModule;